import Plus from "../../../../assets/icons/plus.svg";

export default function icon(props) {
	return <Plus {...props} />;
}
